<template>
  <div class="cmp-header" :class="{'home': activeMenu === '/home', 'menu':showMenu}">
    <div class="header-box">
      <div class="header-left">
        <img class="logo g-pointer" src="~@images/logo.png" alt @click="goHome">
        <!-- <h1>文物山东</h1> -->
      </div>

      <!-- text-color="#000"
      active-text-color="#b29551" -->
      <!-- <el-menu style="display:none;" :default-active="activeMenu" menu-trigger="click" class="el-menu-top1"
        mode="horizontal" @select="handleSelect" background-color="transparent">
        <template v-for="(item, index) in menus.slice(0,9)">
          <el-menu-item class="m-menu-top" :index="item.path" :key="index"
            v-if="!item.children">{{item.title}}</el-menu-item>

          <template v-else>
            <el-submenu popper-class="dl-wrapper" :index="item.path" class="my-submenu" :key="index"
              :popper-append-to-body="true">
              <template slot="title">{{item.title}}</template>
              <div class="aaa" style="display: flex;">
                <el-menu-item :index="it.path" :key="i" v-for="(it, i) in item.children">
                  <span class="span-wrapper" :class="{'active': it.path == activePath}"
                    @click="subMenuClk(it)"><span>{{it.title}}</span><img src="../../assets/images/icon_open@2x.png"
                      alt=""></span>
                </el-menu-item>
              </div>
            </el-submenu>
          </template>
        </template>

     <el-submenu index="2" v-show="menus.length>9">
          <template slot="title">更多</template>
          <el-menu-item
            class="m-menu-top"
            :index="item.path"
            :key="index"
            v-for="(item, index) in menus.slice(9)"
          >{{item.title}}</el-menu-item>
        </el-submenu> 
      </el-menu> -->
      <div class="operate">
        <router-link tag="a" :to="'/search'" class="btn-search"><i></i></router-link>

        <!-- <div class="btn-search txt_lan" @click="goEng">
          <i></i>
        </div> -->

        <div class="change-box" :class="{'show': isShowLan}">
          <div class="act_item" @click="showLan">
            <span>中文</span>
            <i class="triangle"></i>
          </div>
          <div class="open-list">
            <div class="item" @click="isShowLan=false">中文</div>
            <div class="item" @click="goEng">English</div>
          </div>
        </div>
        <div class="mask" v-show="isShowLan" @click="isShowLan=false"></div>

        <span class="icon-menu ml-10" :class="{'icon-close': showMenu}" @click="handleShow"><i></i></span>

        <!-- <cmpNoticeCenter ref="cmpNoticeCenter"></cmpNoticeCenter> -->

        <!-- <i class="el-icon el-icon-search g-pointer" v-if="!showSearch" @click="showSearch=true;blurFocus=true;"></i> -->
        <!-- <i class="el-icon el-icon-search g-pointer" v-if="!showSearch" @click="showSearchBox"></i> -->

        <!-- <el-input ref="customerInput" suffix-icon="el-icon-search"
          style="width:300px;position:absolute;right: 100px;top: 10px;z-index: 2;" placeholder="输入关键字"
          @keyup.enter.native="goSearch" @blur="showSearch=false" v-if="showSearch" v-model="key"></el-input> -->

        <!-- <el-upload
          class="g-inline-block"
          action="/singleMuseum/user/updateUserImg"
          accept="image/*"
          :data="configData"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
        >
          <img
            class="g-pic small"
            :src="$store.state.user.headImg || ''"
            alt
            :onerror="defaultHeadImg"
          >
        </el-upload> 
        
        <label class="person ml-10">
          <span class="name m-assist ell">{{$store.state.user.userName}}</span>
        </label>
        
        <span class="m-assist ml-20 g-pointer" @click="loginOut">退出</span>-->

        <!-- 菜单 -->

        <!-- <div class="login g-pointer" @click="goLogin" v-if="!$store.state.user.userName"><span>登录</span></div>
        <el-dropdown trigger="click" @command="handleOperate" v-else>
          <div class="head-img-box">
            <img :src="$store.state.user.headImg || ''"
              alt
              :onerror="defaultHeadImg"
            >
            <label class="person ml-10">
              <span class="name m-assist ell">{{$store.state.user.userName}}</span>
            </label>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">个人中心</el-dropdown-item>
            <el-dropdown-item command="2">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>

    <!-- @click="showMenu=false" -->
    <!--  @select="handleSelect" @touchmove.prevent -->
    <div class="overlay">
      <div class="menu-box" :class="{'anim': showMenu}">
        <el-menu class="el-menu-top" :default-active="activeMenu" @select="handleSelect" background-color="transparent" router>
          <template v-for="(item, index) in menus">
            <!--1级菜单：当有子菜单时-->
            <template v-if="item.children">
              <el-submenu :index="item.path" :key="index">
                <!--1级菜单名-->
                <template slot="title">
                  <span slot="title"  class="pl-0" >{{ item.title }}</span>
                </template>

                <template v-for="(subItem,i) in item.children">
                  <!--2级菜单：当有子菜单时-->
                  <template v-if="subItem.children">
                    <el-submenu :index="subItem.path" :key="i">
                      <!--2级菜单名-->
                      <template slot="title">
                        <span slot="title" class="pl-40">{{ subItem.title }}</span>
                      </template>
                      <template v-for="(ThreeItem,j) in subItem.children">
                        <!--3级菜单名-->
                        <el-menu-item :index="ThreeItem.path"   :key="j">
                          <span class="pl-80">
                            {{ ThreeItem.title }}
                          </span>
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                  <!--2级菜单：当无子菜单时-->
                  <template v-else>
                    <!--2级菜单名-->
                    <el-menu-item :index="subItem.path" :key="i">
                      <span slot="title" class="pl-40">{{ subItem.title }}</span>
                    </el-menu-item>
                  </template>
                </template>
              </el-submenu>
            </template>
            <!--1级菜单：当无子菜单时-->
            <template v-else>
              <!--1级菜单名-->
              <el-menu-item class="m-menu-top pl-0" :index="item.path" :key="index">
                <span slot="title">{{ item.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
      <!-- <div class="menu-box">
        <el-menu :default-active="activeMenu" menu-trigger="click" class="el-menu-top" mode="horizontal"
          @select="handleSelect" background-color="transparent">
          <template v-for="(item, index) in menus.slice(0,9)">
            <el-menu-item class="m-menu-top" :index="item.path" :key="index"
              v-if="!item.children">{{item.title}}</el-menu-item>

            <template v-else>
              <el-submenu popper-class="dl-wrapper" :index="item.path" class="my-submenu" :key="index"
                :popper-append-to-body="true">
                <template slot="title">{{item.title}}</template>
                <div class="aaa" style="display: flex;">
                  <el-menu-item :index="it.path" :key="i" v-for="(it, i) in item.children">
                    <span class="span-wrapper" :class="{'active': it.path == activePath}"
                      @click="subMenuClk(it)"><span>{{it.title}}</span><img src="../../assets/images/icon_open@2x.png"
                        alt=""></span>
                  </el-menu-item>
                </div>
              </el-submenu>
            </template>
          </template>

          <el-submenu index="2" v-show="menus.length>9">
            <template slot="title">更多</template>
            <el-menu-item
              class="m-menu-top"
              :index="item.path"
              :key="index"
              v-for="(item, index) in menus.slice(9)"
            >{{item.title}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      blurFocus: true,
      activePath: '',
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      // activeMenu: this.$route.path,
      activeMenu: '/' + this.$route.path.split('/')[1],
      key: '',
      showSearch: false,
      menus: [
        {
          title: '首页',
          path: '/home'
        },
        {
          title: '导览',
          path: '/museum',
          children: [
            {
              title: '开放时间',
              path: '/museum/open-time?type=1'
            },
            {
              title: '票务信息',
              path: '/museum/ticket?type=2'
            },
            {
              title: '交通路线',
              path: '/museum/traffic?type=3'
            },
            {
              title: '参观须知',
              path: '/museum/notice?type=4'
            },
            {
              title: '展区导引',
              path: '/museum/guide?type=5'
            },
            {
              title: '馆内服务',
              // path: '/museum/explain',
              children: [
                {
                  title: '讲解服务',
                  path: '/museum/explain?type=6'
                },
                {
                  title: '语音导览服务',
                  path: '/museum/voice?type=6'
                },
                {
                  title: '餐吧及其他设施',
                  path: '/museum/dinning-bar?type=6'
                },
              ]
            },
          ]
        },
        {
          title: '展览',
          path: '/exhibition',
          // children: [
          //   {
          //     title: '当前展览',
          //     path: '/exhibition',
          //   },
          //   {
          //     title: '数字展厅',
          //     path: '/exhibition/digital',
          //   },
          //   {
          //     title: '观众策展',
          //     path: '/exhibition/curation',
          //   },
          //   // {
          //   //   title: '十大精品展览',
          //   //   path: '/exhibition/high-quality',
          //   // }
          // ]
        },
        {
          title: '藏品',
          path: '/collect'
        },
        {
          title: '教育',
          path: '/education'
        },
        {
          title: '学术',
          path: '/research'
        },
        {
          title: '文创',
          path: '/creative'
        },
        {
          title: '关于',
          path: '/about'
        },
        // {
        //   title: '博物馆联盟',
        //   path: '/alliance'
        // },
        // {
        //   title: '文博企业',
        //   path: '/enterprise'
        // },
        // {
        //   title: '参观预约',
        //   path: '/appoint'
        // },
      ],
      showMenu: false,
      isShowLan: false
    }
  },
  watch: {
    // $route(to, from) {
    //   if (to.path.indexOf('museum') == -1) {
    //     // this.activePath = ""
    //   } else {
    //   }
    //   if (this.$route.path === '/alliance/detail') {
    //     // 1 联盟详情  2 企业展会-产品详情  3 企业展会-案例详情
    //     let pageType = this.$route.query.pageType
    //     switch (pageType) {
    //       case '1':
    //         this.activeMenu = '/alliance'
    //         break
    //       case '2':
    //       case '3':
    //         this.activeMenu = '/enterprise'
    //         break
    //     }
    //     return
    //   }

    //   this.activeMenu = '/' + this.$route.path.split('/')[1]
    // }
  },
  methods: {
    showLan() {
      this.isShowLan = true
    },
    goEng() {
      // window.open('https://www.lnmuseum.com.cn/eng/#/homeH5')
      location.href = '/eng/#/homeH5'
    },
    handleShow() {
      this.showMenu = !this.showMenu
      if (this.showMenu) {
        this.stopScroll()
      } else {
        this.canScroll()
      }
    },
    subMenuClk(it) {
      this.activePath = it.path
      console.log(it)
    },
    handleOperate(val) {
      if (val === '1') {
        this.$router.push({ path: '/person' })
      } else if (val === '2') {
        this.loginOut()
      }
    },
    goHome() {
      this.$router.push({
        path: '/home'
      })
    },
    goLogin() {
      this.$router.push({
        path: '/login'
      })
    },
    goSearch() {
      console.log('搜索', this.key)
    },
    // 显示搜索框
    showSearchBox() {
      this.showSearch = true
      this.$nextTick(() => {
        this.$refs.customerInput.$el.querySelector('input').focus()
      })
    },
    handleSelect(key) {
      // handleSelect(key, keyPath) {
      // if (key === '/home') {
      //   // if(key === '/approve' || key === '/home' || key === '/digital') {
      //   // this.$message.warning('建设中')
      //   return
      // }
      this.showMenu = false
      this.canScroll()
      this.$router.push(key)
    },
    loginOut() {
      this.$store.dispatch('LoginOut')
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.cmp-header {
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 99;
  width: 100%;
  height: $headerHeight;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  // box-shadow: 0 3px 8px 2px #f0f4f740;
  &.menu {
    height: 100vh;
  }

  .pl-0{
    padding-left: 0 !important;
  }

  .pl-40{
    padding-left: 40px !important;
  }

  .pl-60{
    padding-left: 60px !important;
  }

  .pl-80{
    padding-left: 80px !important;
  }
  // &.home {
  //   position: absolute;
  //   background: rgba($color: #000, $alpha: 0.5);
  //   /deep/ .el-menu--horizontal > .el-menu-item,
  //   /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  //     color: #fff;
  //   }
  //   .operate {
  //     color: #fff;
  //     .name{
  //       color: #fff;
  //     }
  //   }
  // }
  .header-box {
    flex-shrink: 0;
    position: relative;
    z-index: 9;
    width: 100%;
    height: 110px;
    // overflow: hidden;
    padding: 0 36px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon-menu {
    // width: 100px;
    padding: 20px;
    box-sizing: border-box;
    i {
      display: inline-block;
      width: 44px;
      height: 40px;
      background: url(~@images/icon_expand@2x.png) no-repeat center center;
      background-size: 100% 100%;
    }
    &.icon-close {
      i {
        width: 45px;
        height: 43px;
        background: url(~@images/icon-close.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  .btn-search {
    // width: 100px;

    display: flex;
    align-items: center;
    justify-content: end;
    height: 50px;
    line-height: 50px;
    padding: 20px;
    i {
      // margin-right: 10px;
      width: 44px;
      height: 44px;
      background: url(~@images/icon_search@2x.png) no-repeat center center;
      background-size: contain;
    }
    &.txt_lan {
      i {
        width: 54px;
        height: 54px;
        background: url(~@images/icon_lan.svg) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  .change-box {
    position: relative;
    padding-right: 40px;
    margin: 0 5px 0 10px;
    .act_item {
      color: #000;
      line-height: 110px;
      font-size: 32px;
      cursor: pointer;
      .triangle {
        margin-top: 6px;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border: solid 12px #333;
        border-bottom: solid 12px transparent;
        border-left:  solid 12px transparent;
        border-right: solid 12px transparent;
      }
    }
    .open-list {
      position: absolute;
      z-index: 12;
      right: 0;
      top: 110px;
      font-size: 20px;
      border: 1px solid #ebeef5;
      background: #fff;
      // width: 120px;
      display: block;
      white-space: nowrap;
      border-radius: 8px;
      box-shadow: 0 4px 24px 0 rgba(0,0,0,.1);
      overflow: hidden;
      // height: 0;
      opacity: 0;
      display: none;
      transition: all .2s;
      .item {
        font-size: 28px;
        padding: 12px 30px;
        line-height: 48px;
        cursor: pointer;
        &:hover {
          background-color: #f3e9db;
          color: $primary;
        }
      }
    }
    &.show {
      .open-list {
        // height: 80px;
        opacity: 1;
        display: block;
      }
    }
  }
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    // background: #fff;
    background: transparent;
    z-index: 10;
  }
  .txt_lan {
    font-size: 32px;
    padding:5px;
  }
  .header-left {
    display: flex;
    align-items: center;
    // padding-left: 20px;
    // margin-right: 30px;
    .logo {
      margin-top: 10px;
      width: 251px;
      // width: 319px;
      // height: 91px;
    }
    h1 {
      display: inline-block;
      color: #000;
      line-height: 50px;
      margin-bottom: 0;
    }
  }
  .head-pic {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .el-menu-top {
    flex: 1;
    border: none;
    display: flex;
    justify-content: center;
  }
  .operate {
    // padding-right: 40px;
    margin-right: -20px;
    // width: 270px;
    width: auto;
    height: 100%;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    color: #000;
    .el-icon {
      margin-right: 36px;
    }
    .head-img-box {
      display: inline-block;
      outline: none;
      cursor: pointer;
      img {
        width: 25px;
        height: 25px;
        vertical-align: middle;
        border-radius: 100%;
      }
    }
    .person {
      cursor: pointer;
      .name {
        max-width: 90px;
        display: inline-block;
        position: relative;
        top: 6px;
      }
      img {
        margin-right: 10px;
        display: inline-block;
        width: 40px;
        height: 40px;
        vertical-align: middle;
        border-radius: 100%;
      }
    }
  }
}
// 重置element-ui样式
// .cmp-header {
//   /deep/ .el-menu--horizontal > .el-menu-item,
//   /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
//     position: relative;
//     // min-width: 100px;
//     // height: 120px;
//     // line-height: 120px;
//     // text-align: left;
//     // border-width: 4px;
//     // border-bottom: none;
//     // border-bottom: solid 2px $primary;
//     @include menuTop;
//     &.is-active {
//       color: $primary;
//     }
//   }
//   /deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
//     color: $primary;
//   }

//   /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
//   /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
//     // color: $primary;
//     background-color: transparent !important;
//   }
//   /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
//     color: $primary;
//   }

//   // 二级菜单样式
//   /deep/ .el-menu--horizontal {
//     .el-menu-item {
//       padding: 0;
//       margin: 0 36px;
//       border-bottom: solid 1px rgba($color: #000000, $alpha: 0.2) !important;
//     }
//     .el-submenu__title {
//       padding: 0;
//       margin: 0 36px;
//       a {
//         display: block;
//         line-height: 120px;
//         color: #000;
//         &:hover {
//           background-color: transparent !important;
//           color: $primary;
//         }
//         &.router-link-active {
//           color: $primary;
//         }
//       }
//       i {
//         display: none;
//       }
//       &:hover {
//         background-color: transparent !important;
//         color: $primary;
//       }
//     }

//     .el-submenu.is-active {
//       color: $primary;
//       // border-bottom: solid 2px $primary;
//       @include menuTopActive;
//       .el-submenu__title {
//         a {
//           color: $primary;
//         }
//       }
//     }
//   }

//   .el-icon-search {
//     position: relative;
//     font-size: 22px;
//     &:before {
//       color: #979797;
//       display: none;
//     }
//     // &:after {
//     //   position: absolute;
//     //   right: -18px;
//     //   top: 2px;
//     //   display: block;
//     //   content: '';
//     //   width: 1px;
//     //   height: 20px;
//     //   background: rgba($color: #979797, $alpha: 0.2);
//     // }
//   }
// }

// 下拉框二级菜单
// /deep/ .my-submenu {
//   .el-menu--horizontal {
//     background: transparent;
//     .el-menu--popup {
//       display: flex;
//       box-shadow: none;
//       margin-top: 13px;
//       .el-menu-item {
//         margin: 0;
//         padding: 0 30px;
//         min-width: auto;
//         color: #fff;
//         font-size: 16px;
//         position: relative;
//         z-index: 5;
//         &:hover {
//           background-color: transparent !important;
//           color: $primary;
//         }
//         // TODO
//         &.is-active {
//           // color: #909399;
//         }
//       }
//     }
//   }
//   &:after {
//     display: none;
//     // display: block;
//     // opacity: 0;
//     // transition: all 2s;
//     // content: '';
//     // width: 100vw;
//     // height: 50px;
//     // position: fixed;
//     // left: 0;
//     // top: 120px;
//     // background: rgba(178, 149, 80, 0.6);
//     // z-index: 0;
//   }
//   &.is-opened {
//     &:after {
//       display: block;
//       // opacity: 1;
//     }
//   }
// }
// // 下拉框二级菜单
// /deep/ .el-menu--horizontal {
//   .el-menu--popup {
//     .el-menu-item {
//       padding: 0 30px;
//       &:hover {
//         background-color: transparent !important;
//         color: $primary;
//       }
//       // &.is-active {
//       //   color: $primary;
//       // }
//       // TODO
//       &.is-active {
//         color: #909399;
//       }
//     }
//   }
// }

// 移动端
// .overlay {
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: rgba(75,67,59,.7);
//   z-index: 99;
//   overflow: hidden;
// }
.overlay {
  box-sizing: border-box;
  width: 100%;
  height: 0;
  flex: 1;
  margin-bottom: 50px;
}
.menu-box {
  position: fixed;
  bottom: 0;
  // left: 0;
  top: $headerHeight;
  // overflow: hidden;
  margin-top: 24px;
  border-top: 1px solid rgba($color: #000000, $alpha: 0.2);
  overflow: auto;
  z-index: 100;
  width: 100%;
  padding: 0 36px;
  // height: 100%;
  height: 0;
  background: #fff;
  box-sizing: border-box;
  transition: all .3s;
  opacity: 0;
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
  .el-menu-top {
    display: flex;
    flex-direction: column;
    .el-menu-item,
    /deep/.el-submenu > .el-submenu__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: none !important;
      height: auto;
      padding: 43px 0;
      padding-left: 0 !important;
      position: relative;
      font-size: 36px;
      text-align: left;
      border-width: 4px;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.2);
      .el-submenu__icon-arrow {
        position: relative;
        font-size: 40px;
        color: #000;
        font-weight: bold;
      }
    }
  }
  &.anim {
    opacity: 1;
    height: calc(100% - 150px);
  }
}
</style>

